import React from "react";

const PageHeader = ({ icon: Icon, title, subtitle, action, className = "" }) => (
  <div
    className={`card p-3.5 sm:p-6 opacity-0 animate-fade-in-up ${className}`}
    style={{ animationDelay: "0ms", animationFillMode: "forwards" }}
  >
    <div className={`flex gap-3 sm:gap-4 ${action ? "flex-col sm:flex-row sm:items-center sm:justify-between" : "items-center"}`}>
      <div className="flex items-center gap-2.5 sm:gap-4 min-w-0">
        <div
          className="w-11 h-11 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl flex items-center justify-center shadow-md sm:shadow-lg transition-transform duration-300 sm:hover:scale-110 sm:hover:rotate-6 shrink-0"
          style={{
            background: "linear-gradient(135deg, var(--primary-500), var(--primary-600))",
            boxShadow: "0 10px 15px -3px var(--glow-color)",
          }}
        >
          <Icon className="w-5 h-5 sm:w-7 sm:h-7 text-white" />
        </div>
        <div className="min-w-0">
          <h1 className="page-title">{title}</h1>
          {subtitle && (
            <p className="page-subtitle mt-0.5 line-clamp-2 sm:line-clamp-none">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {action}
    </div>
  </div>
);

export default PageHeader;
